import { render, staticRenderFns } from "./video-content.vue?vue&type=template&id=08db9c8d&scoped=true"
import script from "./video-content.vue?vue&type=script&lang=js"
export * from "./video-content.vue?vue&type=script&lang=js"
import style0 from "./video-content.vue?vue&type=style&index=0&id=08db9c8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db9c8d",
  null
  
)

export default component.exports